<template>
  <Div class="add_construction">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          ref="popupCheck"
          v-if="popup == 'check'"
          :text="successText"
          :enterType="postLoading"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess
          v-if="popup == 'success'"
          :text="successText"
          @check="poupupEnter"
        ></PopupSuccess>
        <PopupError
          v-if="popup == 'error'"
          :text="successText"
          @check="poupupEnter"
        ></PopupError>
      </Popup>
    </MyTransition>
    <div class="contain_white notice_block">
      <div class="form_input flex">
        <label> 申請日期 </label>
        <div>
          <template v-if="!id">
            {{ this.$moment().format("YYYY-MM-DD") }}
          </template>
          <template v-else>
            {{formInput.apply_date}}
          </template>
          
        </div>
      </div>
      <div class="form_input flex">
        <label> 工程編號 </label>
        <div>{{formInput.form_id}}</div>
      </div>
      <div class="form_input flex">
        <label>
          工程名稱
          <span class="must">*</span>
        </label>
        <div>
          <input
            placeholder=""
            v-model="formInput.name"
            class="input_primary"
          />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          工程內容說明
          <span class="must">*</span>
        </label>
        <div>
          <textarea
            class="input_primary notice_textarea"
            v-model="formInput.content"
          />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          施工日期
          <span class="must">*</span>
        </label>
        <div class="time_range flex">
          <el-date-picker
            v-model="formInput.start_date"
            type="date"
            @change="clearEndDate"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            placeholder="Start-day"
            popper-class="picker-date"
          ></el-date-picker>
          <div>
            <i class="el-icon-caret-right"></i>
          </div>
          <el-date-picker
            v-model="formInput.end_date"
            type="date"
            :disabled="!formInput.start_date"
            :picker-options="pickerOptions_end"
            value-format="yyyy-MM-dd"
            placeholder="End-day"
            popper-class="picker-date"
          ></el-date-picker>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          需求單位
        </label>
        <div>{{ this.$store.state.user.name }}</div>
      </div>
      <div class="form_input flex">
        <label>
          承辦人員
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            class="width_percent"
            v-model="formInput.employee_id"
            filterable
            placeholder="請選擇"
          >
            <el-option
              v-for="item in options.employee"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          作業區域
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            class="width_percent"
            v-model="formInput.area_id"
            filterable
            multiple
            placeholder="請選擇"
          >
            <el-option
              v-for="item in options.location"
              :key="item.id"
              :label="item.location"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="form_input flex">
        <label>
          承攬商名稱
          <span class="must">*</span>
        </label>
        <div>
          <el-select
            class="width_percent"
            v-model="formInput.vendor_id"
            filterable
            multiple
            placeholder="請選擇"
          >
            <el-option
              v-for="item in options.contractor"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="add_notice_btn flex">
      <button class="btn_primary" @click="enter">送出</button>
      <button class="btn_gray" @click="returnLogin">返回</button>
    </div>
  </Div>
</template>
<style lang="scss">
.construction_id {
  font-size: 12px;
  color: var(--fontGray);
}
.width_percent{
  width: 100%;
}
.add_construction {
  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;
    .notice_textarea {
      min-height: 50px;
    }
    .time_range {
      align-items: center;
      // justify-content: space-between;
      i.el-icon-caret-right {
        margin: 0 10px;
      }
    }
    label {
      flex: 2;
      font-weight: bold;
      span {
        color: var(--subColor);
      }
    }
    > div {
      flex: 8;
      input,
      textarea {
        width: 100%;
      }
    }
    .special_option {
      max-width: 100%;
      label {
        &.is-checked {
          span {
            color: #409eff;
            font-weight: bold;
          }
        }
      }
      span {
        color: var(--fontGray);
      }
      .el-checkbox-group {
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: left;
        label {
          display: block;
          font-weight: normal;
        }
      }
    }
  }

  .file {
    .file_list {
      margin: 5px 0;
      padding: 10px 10px 10px 10px;
      border: 1px dashed #ccc;
      border-radius: 4px;
      p:first-child {
        flex: 3;
      }
    }
    .file_input {
      margin: 20px 0px;
      input {
        display: none;
      }
    }
    .btn_primary,
    .btn_error {
      font-size: 12px;
      cursor: pointer;
      font-weight: normal;
    }
  }
  .add_notice_btn {
    width: 500px;
    margin: 20px auto;
    button {
      margin: 5px;
    }
  }
}
// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
    .el-date-picker__header {
        button:nth-child(1) {
            display: none;
        }
        button:nth-child(5) {
            display: none;
        }
    }
}
</style>

<script>
import mixins from "@/components/mixins.js";
export default {
  name: "apply-construction",
  mixins: [mixins],
  data() {
    return {
      formInput: {
        apply_date:"",
        form_id:"",
        name: "",
        content: "",
        start_date: "",
        end_date: "",
        employee_id: "",
        area_id: [],
        vendor_id: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() <= Date.now() - 8.64e7 ||
            time.getTime() > Date.now() + (86400000*37)
          );
        },
      },
      pickerOptions_end: {
        disabledDate: (time) => {
          return this.dealDisabledDate(time);
        },
      },
      options: {
        contractor: [],
        special: [],
        employee: [],
        location: [],
      },
      popupStatus: false,
      successText: null,
      popup: null,
      postLoading:false,
      action: {
        index: null,
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  created() {
    if (this.id) {
      //填充修改
      this.getData();
    }
    this.getContractor();
    this.getSpecialOption();
    this.getEmployee();
    this.getArea();
  },
  methods: {
    dealDisabledDate(time) {
      //把時間單獨拉出來
      const todayTime = new Date(this.formInput.start_date).getTime();
      //disable的條件為，不能選今日以前，且範圍為0-37天以內
      return (
        time.getTime() <= todayTime - 8.64e7 ||
        time.getTime() > Date.now() + (86400000*37)
      );
    },
    getContractor() {
      this.$http.api.admin.vendorList().then((res) => {
        res.data.forEach((el) => {
          if (el.is_pass == 2) {
            let obj = {};
            obj["id"] = el.vendor_id;
            obj["name"] = el.vendor_chinese;
            this.options.contractor.push(obj);
          }
        });
      });
    },
    getEmployee() {
      this.$http.api.admin.email().then((res) => {
        this.options.employee = res.data
          .map((el) => {
            return {
              id: el.id,
              name: el.name,
              account: el.account,
            };
          })
          .filter((el) => {
            return el.account;
          });
      });
    },
    getArea() {
      this.$http.api.admin.location().then((res) => {
        this.options.location = res.data;
      });
    },
    getSpecialOption() {
      this.$http.api.admin.specialOperation().then((res) => {
        this.options.special = res.data;
      });
    },
    getData() {
      this.$http.api.admin.getApplication(this.id).then((res) => {
        //填充文字
        for (let key in this.formInput) {
          this.formInput[key] = res.data[key];
        }
      });
    },
    returnLogin() {
      this.$router.go(-1);
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.returnLogin();
      }
    },
    enter(){
      this.popupStatus = true;
      this.successText = "確定送出申請單嗎？送出後不可更改刪除";
      this.popup = "check";
    },
    popupAction() {
      //判斷必填
      let must = ["name","content","employee_id","area_id","vendor_id", "start_date", "end_date"];
      const mustList = this.mustField({
        key:must,
        data:this.formInput
      });
      if (mustList.length !== 0) {
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫必要欄位:${mustList.join()}`;
      } else {
        this.postLoading = true;
        //判斷修改還是新增
        if (this.id) {
          console.log("修改");
          this.$http.api.admin
            .postApplication(
              {
                form_input: this.formInput,
              },
              this.id
            )
            .then((res) => {
              this.postLoading = false;
              this.popupStatus = true;
              this.successText = "成功";
              this.popup = "success";
            })
            .catch((error) => {
              
              this.postLoading = false;
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "新增失敗";
            });
        } else {
          this.$http.api.admin
            .postApplication(this.formInput,
            )
            .then((res) => {
              this.postLoading = false;
              this.popupStatus = true;
              this.successText = "成功";
              this.popup = "success";
            })
            .catch((error) => {
              this.postLoading = false;
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "新增失敗";
            });
        }
      }
    },
    clearEndDate(e) {
      if (e == null) {
        this.formInput.end_date = "";
      }
    },
  },
};
</script>